"use client";

import { XIcon, Menu as MenuIcon } from "lucide-react";
import Link from "next/link";
import { useState } from "react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import Wrapper from "@/components/common/wrapper";
import Menu from "@/components/common/menu";
import MobileMenu from "@/components/common/mobile-navbar";
import Image from "next/image";
import blokc from "@/images/blokc.png";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="relative w-full h-full">
      {/* background blur bar */}
      <div className="z-[99] fixed pointer-events-none inset-x-0 h-[100px] bg-[rgba(255,255,255,0.6)] backdrop-blur-sm [mask:linear-gradient(to_bottom,#000_20%,transparent_calc(100%-20%))]"></div>

      <header
        className={cn(
          "fixed top-4 inset-x-0 mx-auto 2xl:max-w-[1980px] px-4 md:px-8 z-[100] transform th",
          isOpen ? "h-[calc(100%-24px)] overflow-hidden" : "h-16"
        )}
      >
        <Wrapper className="backdrop-blur-lg rounded-xl lg:rounded-2xl border border-[rgba(124,124,124,0.2)] px-4 md:px-6 flex items-center justify-start">
          <div className="flex items-center justify-between w-full sticky mt-[12px] lg:mt-[10px] mb-auto inset-x-0">
            {/* Logo only */}
            <div className="flex items-center lg:flex-none pl-2 md:pl-4">
              <Link href="/" className="relative w-[160px] h-[40px]">
                <Image
                  src={blokc}
                  alt="BLOKC logo"
                  fill
                  className="object-contain"
                  priority
                />
              </Link>
            </div>

            {/* Menu aligned to the right */}
            <div className="hidden lg:flex items-center justify-end flex-1 mr-4">
              <Menu />
            </div>

            {/* CTA Button + Hamburger */}
            <div className="items-center flex gap-3 lg:gap-6 pr-2 md:pr-4">
              <Button
                size="icon"
                variant="ghost"
                onClick={() => setIsOpen((prev) => !prev)}
                className="lg:hidden p-2 w-10 h-10"
              >
                {isOpen ? (
                  <XIcon className="w-5 h-5 duration-300" />
                ) : (
                  <MenuIcon className="w-5 h-5 duration-300" />
                )}
              </Button>
            </div>
          </div>

          {/* Mobile Menu */}
          <div className="lg:hidden flex">
            <MobileMenu isOpen={isOpen} setIsOpen={setIsOpen} />
          </div>
        </Wrapper>
      </header>
    </div>
  );
};

export { Navbar };
